export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  readTime: string;
  category: string;
}

export const articles: Article[] = [
  {
    slug: 'cssbuy-sheet-complete-guide',
    title: 'The Complete CSSBuy Sheet Guide for 2026',
    excerpt: 'Everything you need to know about finding the best CSSBuy spreadsheet picks — from sneakers to accessories, with insider tips on QC, shipping, and spotting top-tier finds.',
    readTime: '12 min read',
    category: 'Buying Guide',
  },
  {
    slug: 'cssbuy-spreadsheet-top-finds',
    title: '50+ Best CSSBuy Spreadsheet Finds This Month',
    excerpt: 'Our curated list of the hottest CSSBuy spreadsheet discoveries — updated weekly with fresh picks across all categories.',
    readTime: '8 min read',
    category: 'Finds',
  },
  {
    slug: 'cssbuy-qc-spreadsheet-tips',
    title: 'CSSBuy QC Spreadsheet: How to Spot Quality Before You Buy',
    excerpt: 'Master the art of QC with our comprehensive guide to reading CSSBuy quality check spreadsheets and avoiding common pitfalls.',
    readTime: '10 min read',
    category: 'Guide',
  },
];

export const testimonials = [
  {
    name: 'Marcus J.',
    role: 'Verified CSSBuy User',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20man%20with%20short%20dark%20hair%2C%20wearing%20a%20simple%20white%20shirt%2C%20clean%20studio%20lighting%2C%20neutral%20warm%20gray%20background%2C%20friendly%20expression%2C%20editorial%20portrait%20style%2C%20minimalist%20composition&width=96&height=96&seq=avatar-marcus-01&orientation=squarish',
    quote: 'This CSSBuy spreadsheet hub saved me hours of searching. The category breakdown makes it incredibly easy to find exactly what I need. Been using it daily for my hauls.',
  },
  {
    name: 'Sophie L.',
    role: 'Fashion Enthusiast',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20with%20blonde%20hair%2C%20wearing%20a%20simple%20cream%20blouse%2C%20soft%20natural%20studio%20lighting%2C%20warm%20beige%20background%2C%20gentle%20smile%2C%20editorial%20portrait%20style%2C%20minimalist%20composition&width=96&height=96&seq=avatar-sophie-02&orientation=squarish',
    quote: 'The buying guides are genuinely helpful — I went from knowing nothing about CSSBuy spreadsheets to confidently picking top-tier items. The QC tips are gold.',
  },
  {
    name: 'Alex K.',
    role: 'Streetwear Collector',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20man%20in%20his%2020s%20with%20curly%20brown%20hair%2C%20wearing%20a%20black%20t-shirt%2C%20clean%20studio%20lighting%2C%20neutral%20gray%20background%2C%20confident%20expression%2C%20editorial%20portrait%20style%2C%20minimalist%20composition&width=96&height=96&seq=avatar-alex-03&orientation=squarish',
    quote: 'Finally a site that organizes CSSBuy spreadsheet finds properly. The category navigation is intuitive, and the daily updates keep me coming back for the latest drops.',
  },
];